import { toggleToast } from '@bilibili-maoer/prelude'

import { useState } from 'react'
import { useMount } from 'react-use'

import { match } from 'ts-pattern'

import { InviteDialog } from './invite'

import { useAppDispatch } from '~/app/hooks'
import { Title } from '~/core/components/title'
import SystemSlice from '~/core/slices/system'
import { ContractDetails } from '~/features/guild/contract/components/contract-form'
import { GuildApi } from '~/services/fm/guild'
import CenterCircularProgress from '~/shared/components/center-circular-progress'
import AppNavigate from '~/shared/navigation/app-navigate'
import useAppNavigate from '~/shared/navigation/use-app-navigate'

const NotInGuild = (props: { onMount: () => void }) => {
  useMount(props.onMount)
  return <AppNavigate to=".." />
}

export const GuildRenew = () => {
  const navigate = useAppNavigate()
  const dispatch = useAppDispatch()
  const [inviteDialogContent, setInviteDialogContent] = useState<string>()
  const { data: myGuild, isFetching } = GuildApi.getMyGuild.useQuery(undefined, {
    refetchOnMountOrArgChange: true,
  })
  const [triggerRenew, renewResult] = GuildApi.renewGuildContract.useMutation()

  // TODO: 优化一下写法
  return (
    <>
      <Title>公会续约申请</Title>

      {isFetching ? (
        <CenterCircularProgress />
      ) : !myGuild ? (
        <NotInGuild
          onMount={() => {
            if (renewResult.isUninitialized) {
              dispatch(SystemSlice.actions.pushError('您还未加入公会，请先申请签约'))
            }
          }}
        />
      ) : (
        <ContractDetails
          data={{
            guildId: myGuild.guild_id,
            guildName: myGuild.guild_name,
            masterId: myGuild.user_id,
            rateString: myGuild.rate_string,
            settlement: myGuild.settlement,
          }}
          source="apply"
          operator="renew"
          isLoading={renewResult.isLoading}
          onSubmit={async (input) => {
            if (input.duration !== undefined) {
              match(await triggerRenew({ duration: input.duration }).unwrap())
                .with({ state: 'applied' }, ({ message }) => {
                  toggleToast(message)
                  navigate('..')
                })
                .with({ state: 'invited' }, ({ message }) => {
                  setInviteDialogContent(message)
                })
                .exhaustive()
            }
          }}
        />
      )}

      {myGuild && (
        <InviteDialog
          content={inviteDialogContent}
          ownerId={myGuild.user_id}
          onClose={() => setInviteDialogContent(undefined)}
        />
      )}
    </>
  )
}
